<template>
    <div id="gangSheet">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title" style="width:13%"> Gang Sheet</div>
                    <!-- <a href="javascript:void(0)" class="btn btn-primary pull-right" v-on:click="addLogTime()">
                        <i class="fp-add"></i> Add
                    </a> -->
                    <div class="form-row row-cols-md-3 row-cols-1">
                        <div class="col form-group">
                            <template v-if="canSeeLocation">
                                <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" class='close-remove' :options="locationArr" @input="onLocationChange">
                                </v-select>
                            </template>    
                        </div>
                        <div class="col form-group"></div>
                        <div class="col form-group">
                            <button type="button" class="btn btn-primary pull-right" v-on:click.prevent="addLogTime()" :disabled="disableAddAndDates">
                                <i class="fp-add"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content time-store gang-sheet" >
                       <section v-if="addLog" class="internal-container border-top-table-fl">
                           <div class="table-responsive-sm mt-3">
                               <table aria-describedby="table" class="table table-sm">
                                   <thead>
                                        <tr class="table-header">
                                            <th style="width:300px">Indirect  Labour  Code</th>
                                            <th style="width:50px"></th>
                                            <th style="width:400px">Work  Order</th>
                                            <th style="width:50px"></th>
                                            <th style="width:200px">Total Duration</th>
                                            <th style="width:160px">&nbsp;</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        <tr>
                                            <td>
                                                <v-select v-model="indirectLaborCode"
                                                name="indirectLaborCode"
                                                placeholder="Select Indirect Labor Code." label="text"
                                                :options="indirectLaborCodeArr"
                                                :clearable="true">
                                                </v-select>
                                                <div class="error">{{indirectLaborCodeError}}</div>
                                            </td>
                                            <td style="text-align: center; line-height: 2.5;">
                                                OR
                                            </td>
                                            <td>
                                                <v-select
                                                    v-model="workOrder"
                                                    name="work_order"
                                                    placeholder="Select Work Order."
                                                    label="work_order_no"
                                                    :options="workOrderArr"
                                                    :filterable="true"
                                                    :clearable="true">
                                                </v-select>
                                                <span class="text-danger">{{workOrderError}}</span>
                                            </td>
                                            <td>
                                                &nbsp;
                                            </td>
                                            <td>
                                                <input type="text" class="form-control" v-model="added_duration" id="added_duration" placeholder="Enter Total Duration" name="added_duration" @keypress="isAmountCheck($event)">
                                                <div class="error">{{added_duration_error}}</div>
                                            </td>
                                            <td>
                                                <button type="button" class="btn btn-primary" v-on:click.prevent="saveNewLogTime()"><i class="fp-save" style="float:none;"> </i> Save</button>
                                                <button type="button" class="btn btn-tertiary" v-on:click.prevent="cancelLogTime()"><i class="fp-close" style="float:none;"> </i> Cancel</button>
                                            </td>
                                        </tr>
                                   </tbody>
                               </table>
                           </div>
                       </section>
                        <section class="internal-container bill-view-table border-top-table-fl">
                            <!-- Next Previous Button -->
                            <div class="row">
                                <div class="col-md-3 offset-md-9 text-right pr-4">
                                    <button type="button" id="previousBtn" class="btn btn-primary" v-on:click.prevent="loadUsersAndDates('previous')" :disabled="disableAddAndDates">
                                        <i class="fp-left-arrow bold" aria-hidden="true" style="font-size:16px;"></i> Prev
                                    </button>
                                    <button v-if="isEndDateCurrent == 0" type="button" id="nextBtn" class="btn btn-primary" v-on:click.prevent="loadUsersAndDates('next')" :disabled="disableAddAndDates">
                                        Next <i class="fp-right-arrow bold pr-0" aria-hidden="true" style="font-size:16px;padding-left:5px;"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="table-section-fl mt-3">
                                <div class="form-row">
                                    <div class="col-md-2" v-if="!disableAddAndDates">
                                        <table aria-describedby="table" id="contact_table" class="table table-borderless purchase-order-item-table">
                                            <thead>
                                                <tr>
                                                    <th class="section-title">Technicians</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(techData , index) in technicianArr">
                                                    <tr :key="'tech'+index">
                                                        <td :class="techData.class" v-on:click.prevent="userChange(techData,index)" style="cursor:pointer">
                                                            <a href="javascript:void(0);">{{ techData.name }}</a>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="table-responsive" style="margin-left:-11px;">
                                            <table aria-describedby="table" id="contact_table" class="table table-borderless purchase-order-item-table">
                                                <tr>
                                                    <template v-for="(dateData , ind) in datesArr">
                                                        <!-- <th :key="'date'+ind" :class="dateData.class" v-on:click.prevent="dateChange(dateData,ind)" style="cursor:pointer">
                                                            <a href="javascript:void(0);">{{ dateData.dateValue }}</a>
                                                        </th>     -->
                                                        <template v-if="disableAddAndDates">
                                                            <th :key="'date'+ind" :class="dateData.class">
                                                                <a href="javascript:void(0);" class="disable-link" disabled>{{ dateData.dateValue }}</a>
                                                            </th>
                                                        </template>
                                                        <template v-else>
                                                            <th :key="'date'+ind" :class="dateData.class" v-on:click.prevent="dateChange(dateData,ind)" style="cursor:pointer">
                                                                <a href="javascript:void(0);">{{ dateData.dateValue }}</a>
                                                            </th>
                                                        </template>
                                                    </template>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="form-row">
                                            <!-- Overall Status-->
                                            <div class="col-md-6" v-if="overallStatus != ''">
                                                <h4 class="log-status">Status : {{overallStatus}}</h4>
                                            </div>
                                            <div class="col-md-3" v-if="overallStatus != '' && technicianArr[currentUserIndex] != undefined && technicianArr[currentUserIndex] != null">
                                                <h5 v-if="technicianArr[currentUserIndex].name != undefined && technicianArr[currentUserIndex].name != null">
                                                    {{technicianArr[currentUserIndex].name}}
                                                </h5>
                                            </div>
                                            <!-- Approve Disapprove Btn -->
                                            <div class="col-md-3 btn-groups text-right">
                                                <button v-if="showDelete" type="button" class="btn btn-primary" id="approveLogBtn" v-on:click.prevent="timeLogDelete">Delete</button>
                                                <button v-if="showApproveBtn" type="button" class="btn btn-primary" id="approveLogBtn" v-on:click.prevent="changeStatus('approve')">Approve</button>
                                                <button v-if="showDisapproveBtn" type="button" class="btn btn-danger" id="disapproveLogBtn" v-on:click.prevent="changeStatus('done')">Disapprove</button>
                                                <button v-if="approveAll" type="button" class="btn btn-primary" id="approveAllBtn" v-on:click.prevent="changeStatus('approve')">Approve All</button>
                                                <button v-if="disapproveAll" type="button" class="btn btn-danger" id="disapproveAllBtn" v-on:click.prevent="changeStatus('done')">Disapprove All</button>
                                            </div>
                                            <div class="col form-group" v-if="overallStatus != ''">
                                                <div class="custom-checkbox">
                                                    <label for="select_all" class="checkbox-custom">Select All
                                                    <input type="checkbox" v-model="select_all" id="select_all" name="select_all" v-on:click="selectAll($event)">
                                                    <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right-column">
                                            <!-- Log Summary -->
                                            <template v-if="timeLogArr.length > 0">
                                                <template v-for="(logTime ,logIndex) in timeLogArr">
                                                    <div :key="logIndex">
                                                        <template v-if="logTime.log != undefined">
                                                            <!-- Log Summary -->
                                                            <template v-if="logTime.log.length > 0">
                                                                <div class="table-responsive-sm">
                                                                    <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered purchase-order-item-table">
                                                                        <thead>
                                                                            <tr class="table-primary">
                                                                                <th scope="col" style="width:10px;"></th>
                                                                                <th>Type</th>
                                                                                <th>Time</th>
                                                                                <th>Duration</th>
                                                                                <th>Updated</th>
                                                                                <th>Approved</th>
                                                                                <th style="min-width:220px;">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <template v-for="(logVal ,logInd) in logTime.log">
                                                                                <tr :key="'logVal'+logInd">
                                                                                    <!-- <td scope="col" style="width:10px;" v-if="logVal.is_summary == 0 && logVal.wo_log_status != 'wip'"> -->
                                                                                    <td scope="col" style="width:10px;" v-if="logVal.is_summary == 0 && (logVal.end_time != '' || logVal.updated_duration > 0)">
                                                                                        <input type="checkbox" :id="'selectLog' + logInd" @input="logSelect($event,logVal,logInd)"/>
                                                                                    </td>
                                                                                    <td v-else>&nbsp;</td>
                                                                                    <!-- <td v-if="logVal.is_summary == 0">{{logVal.description}}</td>
                                                                                    <td v-else>&nbsp;</td> -->
                                                                                    <td v-if="logVal.is_summary == 0"><span v-fp-html="logVal.description"></span></td>
                                                                                    <td v-else>{{logVal.description}}</td>
                                                                                    <td>{{ logVal.start }} - {{ logVal.end }}</td>
                                                                                    <td>{{logVal.duration}}</td>
                                                                                    <td>
                                                                                        <template v-if="logVal.is_update == 0">
                                                                                        {{logVal.updated}}
                                                                                        </template>
                                                                                        <template v-else>
                                                                                            <!-- Updated Duration Input-->
                                                                                            <input type="text" class="form-control updated-input" v-model="logVal.new_updated_value" :id="'updated_log_val'+logInd" placeholder="Enter Updated Duration" name="updated_log_val" @keypress="isAmountCheck($event)">
                                                                                            <div class="error">{{logVal.updated_duration_error}}</div>
                                                                                            <!-- <div class="form-group">
                                                                                                <input-mask :id="'new_updated_value'+logInd" :alwaysShowMask="true" name="new_updated_value" v-model="logVal.new_updated_value" :mask="timeMask"
                                                                                                    :format-chars="timeMaskOptions.formatChars"
                                                                                                    :always-show-mask="timeMaskOptions.alwaysShowMask" class="form-control">
                                                                                                </input-mask>
                                                                                                <div class="error">{{logVal.updated_duration_error}}</div>
                                                                                            </div> -->
                                                                                        </template>
                                                                                    </td>
                                                                                    <td>{{logVal.approved}}</td>
                                                                                    <!-- <td v-if="logVal.is_summary == 0 && logVal.wo_log_status != 'wip'">Log Status is in progress -->
                                                                                    <td v-if="logVal.is_summary == 0"><!-- Log Status is in progress -->
                                                                                        <template v-if="logVal.is_update == 0">
                                                                                            <a href="javascript:void(0);" class="fp-edit" v-on:click.prevent="editLogEntry($event,logVal,logInd)"></a>
                                                                                        </template>
                                                                                        <template v-else>
                                                                                            <!-- Update and Cancel Button -->
                                                                                            <button type="button" class="btn btn-primary" :id="'updateLogBtn'+logInd" v-on:click.prevent="updateLogEntry($event,logVal,logInd,logVal.new_updated_value,logIndex)">
                                                                                                <i class="fp-reload"> </i>Update</button>
                                                                                            <button type="button" class="btn btn-tertiary" :id="'cancelLogBtn'+logInd" v-on:click.prevent="cancelLogEntry($event,logVal,logInd)">
                                                                                                <i class="fp-close"> </i>Cancel</button>
                                                                                        </template>
                                                                                    </td>
                                                                                    <td v-else>
                                                                                        &nbsp;
                                                                                    </td>
                                                                                </tr>
                                                                            </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                No Log Found.
                                                            </template>
                                                        </template>
                                                        <template v-if="logTime.summary != undefined">
                                                            <!-- Final Summary -->
                                                            <template v-if="logTime.summary.length > 0">
                                                                <div class="table-responsive">
                                                                    <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm purchase-order-item-table">
                                                                        <thead>
                                                                            <tr class="table-primary">
                                                                                <th>Summary</th>
                                                                                <th>Actual Logged In Time</th>
                                                                                <th>Approved Time</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <template v-for="(logSum , sumInd) in logTime.summary">
                                                                                <tr :key="'summary'+sumInd">
                                                                                    <td>{{logSum.summary}}</td>
                                                                                    <td>{{logSum.actual_time}}</td>
                                                                                    <td>{{logSum.approved_time}}</td>
                                                                                </tr>
                                                                            </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                No Summary Found
                                                            </template>
                                                        </template>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <div class="lineitem-main-section" v-if="!disableAddAndDates">
                                                    <h6 class="text-center" style="margin-top:3%;color: #6f6f6f;">No Data Found</h6>
                                                </div>
                                            </template>
                                        </div>
                                        <div class="modal fade lineitem-message-modal" id="lineitem-message-modal" ref="lineitemMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="lineitemMessageModal" aria-hidden="true">
                                            <div class="modal-dialog modal-lg" role="document">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title">Message</h5>
                                                        <button type="button" class="close" id="btnModalMessageClose" v-on:click="hideMessageModal()">&times;</button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <p v-show="closedErrorMsg">Following Work Order Line Item Has Been Already Closed : </p>
                                                        <template v-if="closedLineItems.length">
                                                            <template v-for="(cli,key) in closedLineItems">
                                                                <p :key="'i' + key">{{cli}}</p>
                                                            </template>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- No Technicians Found-->
                                    <div class="col-md-12" v-if="disableAddAndDates">
                                        <div class="lineitem-main-section">
                                            <h6>No Data Found</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";


import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
import moment from 'moment';
// import InputMask from 'vue-input-mask';
// Vue.component('input-mask', InputMask);

export default {
    name: "GangSheet",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Gang Sheet | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,contractMixins],
    data() {
        return {
            permissions: [],
            cantAccessPage: "",
            loading:false,
            technicianArr:[],
            datesArr:[],
            timeLogArr:[],
            currentDateIndex:0,
            currentUserIndex:0,
            logUpdate:false,
            addLog:false,
            overallStatus:"",
            indirectLaborCodeArr:[],
            indirectLaborCode:"",
            indirectLaborCodeError:"",
            workOrder:"",
            workOrderArr:[],
            workOrderError:"",
            added_duration:"",
            added_duration_error:"",
            //defaultClass:"admin-page-content customer-detail",
            selectedLogArr:[],
            showApproveBtn:false,
            showDisapproveBtn:false,
            showDelete:false,
            canAddLog:false,
            canUpdateLog:false,
            canChangeStatus:false,
            oldUpdatedDuration:0,
            isEndDateCurrent:1,
            disableAddAndDates:false,
            approveAll:false,
            disapproveAll:false,
            select_all:false,
            closedErrorMsg:false,
            closedLineItems:[],
            currentLogIndex:0,
            locationArr: [],
            location_id:"",
            role_name:"",
            canSeeLocation:false
        }
    },
    watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'user_log_entry_list') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'user_log_entry_add') {
                        self.canAddLog = true;
                        self.canUpdateLog = true;
                    }
                    if (permissions[i].name == 'user_log_entry_status_change') {
                        self.canChangeStatus = true;
                    }
                }
            }

        }
    },
    computed: {
        timeMask () {
            for(var i = 0;i < this.timeLogArr.length;i++) {
                if (this.timeLogArr[i] != undefined) {
                    if (this.timeLogArr[i].log != undefined && this.timeLogArr[i].log != null) {
                        for(var j = 0;j < this.timeLogArr[i].log.length;j++) {
                            if (this.timeLogArr[i].log[j].is_summary == 0) {
                                if (j == this.currentLogIndex) {
                                    if (!this.timeLogArr[i].log[j].new_updated_value || this.timeLogArr[i].log[j].new_updated_value === '' || this.timeLogArr[i].log[j].new_updated_value[0] === '2') {
                                        return '23:59';
                                    }
                                    return '29:59';
                                }
                            }
                        }
                    }
                }
            }
            return '29:59';
        },
        timeMaskOptions () {
            return { formatChars: { '2': '[0-2]', '3': '[0-3]', '5': '[0-5]', '9': '[0-9]' }, alwaysShowMask: false }
        }
    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData([  'indirectlaborcode','location']);
        //logged in user location
        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            if (userObj.roles.length > 0) {
                for(var i = 0; i < userObj.roles.length; i++){
                    if (userObj.roles[i].name == 'service manager' || userObj.roles[i].name == 'service administrator' || userObj.roles[i].name == 'admin') {
                        self.role_name = userObj.roles[0].name.toLowerCase();
                        self.canSeeLocation = true;
                    }

                }
            }
            if (userObj["location_id"] != null && userObj["location_id"] != '') {
                var locationName = self.ucString(userObj["locationName"]);
                if (userObj["locationCode"] != null && userObj["locationCode"] != "") {
                    locationName += " | ";
                    locationName += userObj["locationCode"];
                }
                self.location_id = {
                    value: userObj["location_id"],
                    text: locationName
                };
            }
        }
        // self.datesArr = self.getCurrentWeek();
        //users and dates
        self.loadUsersAndDates('load');
        // self.technicianArr = self.getUsers();
        // self.currentDateIndex = self.findElementIndex(self.datesArr,"class","active-date");

    },
    methods: {

        //current week dates
        getCurrentWeek() {
            var currentDate = moment();
            var previousDay = moment().subtract(1, 'days').format("MM/DD/YYYY");
            console.log(previousDay);

            var weekStart = currentDate.clone().startOf('isoWeek');
            var weekEnd = currentDate.clone().endOf('isoWeek');

            var days = [];

            for (var i = 0; i <= 6; i++) {
                console.log(moment(weekStart).add(i, 'days').format("MM/DD/YYYY"));
                days.push({
                    dateValue:moment(weekStart).add(i, 'days').format("MM/DD/YYYY"),
                    class:(moment(weekStart).add(i, 'days').format("MM/DD/YYYY") == previousDay)?'active-date':''
                });
            }
            console.log(days);

            return days;
        },

        dateChange(dateData,index) {
            var self = this;
            console.log("index :: " + index);
            console.log(dateData);
            for(var i = 0;i < self.datesArr.length;i++) {
                if (self.datesArr[i] != undefined) {
                    if (i == index) {
                        this.$set(self.datesArr[i], 'class', 'active-date');
                        self.currentDateIndex = index;
                        self.loadTimeLogData(self.technicianArr[self.currentUserIndex].id,self.datesArr[index].dateValue);//date change
                        self.uncheckSelectedLog();
                        self.showApproveBtn = false;
                        self.showDisapproveBtn = false;
                        self.showDelete = false;
                        self.select_all = false;
                        self.approveAll = false;
                        self.disapproveAll = false;
                    }else{
                        this.$set(self.datesArr[i], 'class', '');
                    }
                }
            }
        },

        getUsers() {
            var self = this;
            var userArr = ["A","B","C","D","E","F"];
            var arr = [];

            for(var i = 0;i < userArr.length;i++) {
                arr.push({
                    name:userArr[i],
                    class:(i == 0)?'active-user':''
                });
            }

            return arr;
        },

        userChange(userData,index) {
            var self = this;
            console.log("index :: " + index);
            console.log(userData);
            for(var i = 0;i < self.technicianArr.length;i++) {
                if (self.technicianArr[i] != undefined) {
                    if (i == index) {
                        this.$set(self.technicianArr[i], 'class', 'active-user');
                        self.currentUserIndex = index;
                        self.loadTimeLogData(self.technicianArr[index].id,self.datesArr[self.currentDateIndex].dateValue);//user change
                        if (self.addLog) {
                            self.indirectLaborCode = "";
                            self.workOrder = "";
                            self.workOrderArr = [];
                            self.added_duration = "";
                            self.added_duration_error = "";
                            self.indirectLaborCodeError = "";
                            self.workOrderError = "";
                            self.loadWOLineItem(self.technicianArr[index].id);
                            self.uncheckSelectedLog();
                            self.showApproveBtn = false;
                            self.showDisapproveBtn = false;
                            self.select_all = false;
                            self.approveAll = false;
                            self.disapproveAll = false;
                            self.showDelete = false;
                        }
                    }else{
                        this.$set(self.technicianArr[i], 'class', '');
                    }
                }
            }
        },

        findElementIndex(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        },
        //users and dates
        loadUsersAndDates(value) {
            var self = this;
            if (value == "load") {//Page Load
                var fields = {
                    flag:value
                };
            }else if (value == "location") {
                var fields = {
                    flag:value,
                    location:self.location_id.value
                };
            }else{
                //Next or Previous
                var selectedUser = self.technicianArr[self.currentUserIndex].id;
                var userIndex = self.currentUserIndex;
                var selectedDate = self.datesArr[self.currentDateIndex].dateValue;
                var dateIndex = self.currentDateIndex;
                var startDate = self.datesArr[0].dateValue;
                var endDate = self.datesArr[self.datesArr.length - 1].dateValue;
                var locationId = "";
                if (self.location_id != undefined && self.location_id != null && self.location_id.value != null) {
                    locationId = self.location_id.value;
                }

                var fields = {
                    technician:selectedUser,
                    user_index:userIndex,
                    date:selectedDate,
                    date_index:dateIndex,
                    start:startDate,
                    end:endDate,
                    flag:value,
                    location:locationId
                };
            }
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/gang-sheet/users-date",
                type: "POST",
                headers: this.ajxHeaders,
                data:fields,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.datesArr = [];
                        self.datesArr = data.content.dates;//dates
                        self.currentDateIndex = self.findElementIndex(self.datesArr,"class","active-date");//previous day date active
                        self.technicianArr = data.content.technicians;//technicians
                        self.isEndDateCurrent = data.content.current_end;
                        if (self.technicianArr.length > 0) {
                            if (value == "load" || value == "location") {
                                self.loadTimeLogData(self.technicianArr[0].id,self.datesArr[self.currentDateIndex].dateValue);
                            }else{
                                self.currentUserIndex = self.findElementIndex(self.technicianArr,"class","active-user");//active-user
                                self.loadTimeLogData(self.technicianArr[self.currentUserIndex].id,self.datesArr[self.currentDateIndex].dateValue);
                            }
                        }else{
                            self.timeLogArr = [];
                            self.overallStatus = "";
                            self.uncheckSelectedLog();
                            self.showApproveBtn = false;
                            self.showDisapproveBtn = false;
                            self.select_all = false;
                            self.approveAll = false;
                            self.disapproveAll = false;
                            self.showDelete = false;
                        }
                        //disable dates, previous and next and Add button if No Technicians found for Logged In User
                        if (data.content.disabled == 1) {
                            self.disableAddAndDates = true;
                        }else{
                            self.disableAddAndDates = false;
                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'gang-sheet-users-date')
                }
            });
        },

        loadTimeLogData(userId,selectedDate) {
            var self = this;

            var fields = {
                technician:userId,
                date:selectedDate
            };
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/gang-sheet/log-data",
                type: "POST",
                headers: this.ajxHeaders,
                data: fields,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        self.timeLogArr = [];
                        console.log(data.content);
                        if (data.content.time_log.length > 0) {
                            self.timeLogArr = data.content.time_log;
                        }
                        self.overallStatus = data.content.log_status;
                        self.uncheckSelectedLog();
                        self.showApproveBtn = false;
                        self.showDisapproveBtn = false;
                        self.select_all = false;
                        self.approveAll = false;
                        self.disapproveAll = false;
                        self.showDelete = false;
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'gang-sheet-log-data')
                }
            });
        },
        addLogTime() {
            var self = this;
            if (!self.addLog) {
                self.addLog = true;
                //self.defaultClass = "admin-page-content customer-detail padding-class";
                self.indirectLaborCode = '';
                self.workOrder = '';
                self.workOrderArr = [];
                self.added_duration = "";
                self.added_duration_error = "";
                self.indirectLaborCodeError = "";
                self.workOrderError = "";
                var index = self.findElementIndex(self.technicianArr,"class","active-user");
                if (self.technicianArr[index] != undefined) {
                    if (self.technicianArr[index].id != null && self.technicianArr[index].id != undefined) {
                        var userId = self.technicianArr[index].id;
                        self.loadWOLineItem(userId);
                    }
                }
            }else{
                self.addLog = false;
                //self.defaultClass = "admin-page-content customer-detail";
                self.indirectLaborCode = '';
                self.workOrder = '';
                self.workOrderArr = [];
                self.added_duration = "";
                self.added_duration_error = "";
                self.indirectLaborCodeError = "";
                self.workOrderError = "";
            }
        },
        loadWOLineItem(userId) {
            var self = this;
            $.ajax({

                url: process.env.ROOT_API + "/get-etklog",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,
                data:{
                   user_id: userId
                },
                success: function(data) {

                  self.workOrderArr = data;

                },
                error: function(jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR, true, 'get-wo-line-item')
                }
            });
        },
        saveNewLogTime() {
            var self = this;
            var error = false;
            self.indirectLaborCodeError = "";
            self.workOrderError = "";
            self.added_duration_error = "";

            if (!self.added_duration || self.added_duration == 0 || self.added_duration == "") {
                self.added_duration_error = "Total Duration Required.";
                error = true;
            }

            if (!self.logValidate()) {
                error = true;
            }

            if (!error) {

                var technicianId = self.technicianArr[self.currentUserIndex].id;//selected technician id
                var currentDate = self.datesArr[self.currentDateIndex].dateValue;//selected date
                var currentTime = moment().format("HH:mm:ss");


                if(!self.indirectLaborCode) {

                    var fields = {
                        work_order_items_id: self.workOrder.id,
                        technician:technicianId,
                        total:self.added_duration,
                        date:currentDate,
                        time:currentTime
                    }
                }else{
                    var fields = {
                        indirect_labor_code_id: self.indirectLaborCode.value,
                        technician:technicianId,
                        total:self.added_duration,
                        date:currentDate,
                        time:currentTime
                    }
                }

                console.log(fields);
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/gang-sheet/log/add",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: fields,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.addLog = false;
                            //self.defaultClass = "admin-page-content customer-detail";
                            self.indirectLaborCode = '';
                            self.workOrder = '';
                            self.workOrderArr = [];
                            self.added_duration = "";
                            self.added_duration_error = "";
                            self.indirectLaborCodeError = "";
                            self.workOrderError = "";
                            self.loadTimeLogData(self.technicianArr[self.currentUserIndex].id,self.datesArr[self.currentDateIndex].dateValue);//refresh page
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'gang-sheet-add-new-log')
                    }
                });


            }
        },
        cancelLogTime() {
            var self = this;
            self.addLog = false;
            //self.defaultClass = "admin-page-content customer-detail";
            self.indirectLaborCode = '';
            self.workOrder = '';
            self.workOrderArr = [];
            self.added_duration = "";
            self.added_duration_error = "";
            self.indirectLaborCodeError = "";
            self.workOrderError = "";
            self.currentLogIndex = 0;
        },
        logValidate(){
            var self = this;
            var checked = true;

            if (self.indirectLaborCode && self.workOrder) {
                self.indirectLaborCodeError = "Please select labor code or work order";
                if (checked) {
                    checked = false;
                }
            }else{
                if (!self.indirectLaborCode && !self.workOrder) {
                    self.indirectLaborCodeError = "Please select labor code or work order";
                    if (checked) {
                        checked = false;
                    }
                }else {
                    self.indirectLaborCodeError = '';
                    self.workOrderError = '';
                }
            }

            return checked;
        },
        logSelect(event,log,index) {
            console.log("in side loggggg");
            var self = this;
            if ( event.target.checked == true) {
                if (log != undefined) {
                    if (log.id != undefined && log.id != null) {
                        self.selectedLogArr.push({
                            id:log.id,
                            approved:log.approved.toLowerCase(),
                            index:index,
                            wo_log_status:log.wo_log_status,
                            wostatus:log.wostatus
                        });
                    }
                }
            }else{
                var i = self.selectedLogArr.indexOf(log);
                const filteredItems = self.selectedLogArr.filter(function(item) {
                    return item.id !== log.id
                })
                self.selectedLogArr = filteredItems;
                self.select_all = false;
                self.approveAll = false;
                self.disapproveAll = false;
            }
            var statusArr = [];
            for (var i = 0;i < self.selectedLogArr.length;i++) {
                if (self.selectedLogArr[i].wo_log_status == "wip") {
                    //statusArr.push(self.selectedLogArr[i].wo_log_status);//if log in progress
                }else{
                    statusArr.push(self.selectedLogArr[i].approved);
                }
            }
            
            if (statusArr.length > 0) {
                //check all values in array are equal or not
                const allEqual = arr => arr.every( v => v === arr[0] );
                var found = allEqual(statusArr);
                if ( found ) {
                    self.showDelete = true;
                    if (statusArr[0] == "yes") {
                        //Yes then disapprove
                        self.showApproveBtn = false;
                        self.showDisapproveBtn = true;
                    }else if (statusArr[0] == "no") {
                        //No then approve
                        self.showApproveBtn = true;
                        self.showDisapproveBtn = false;
                    }
                }else{
                    self.showDelete = false;
                    self.showApproveBtn = false;
                    self.showDisapproveBtn = false;
                    alert("Please select records either with approved 'Yes' OR 'NO'");
                }
                
            } else {
                self.showDelete = false;
                self.showApproveBtn = false;
                self.showDisapproveBtn = false;
                alert("Please select records either approved 'Yes' OR 'NO'");
            }
        },
        uncheckSelectedLog() {
            var self = this;
            for(var i = 0;i < self.selectedLogArr.length;i++) {
                $("#selectLog" + self.selectedLogArr[i].index). prop("checked", false); //uncheck selected log
            }
            self.selectedLogArr = [];
        },
        changeStatus(status) {
            var self = this;
            self.loading = true;
            var idArr = [];
            for(var i = 0;i < self.selectedLogArr.length;i++) {
                idArr.push(self.selectedLogArr[i].id);
            }
            $.ajax({
                url: process.env.ROOT_API + "/gang-sheet/log/change-status",
                type: "POST",
                headers: this.ajxHeaders,
                data: {arr:idArr,status:status},
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    self.addLog = false;
                    //self.defaultClass = "admin-page-content customer-detail";
                    self.indirectLaborCode = '';
                    self.workOrder = '';
                    self.workOrderArr = [];
                    self.added_duration = "";
                    self.added_duration_error = "";
                    self.indirectLaborCodeError = "";
                    self.workOrderError = "";
                    self.uncheckSelectedLog();
                    if (data.content.closed && data.content.closed.length > 0) {
                        self.closedErrorMsg = true;
                        self.closedLineItems = data.content.closed;
                        $("#lineitem-message-modal").modal("show");
                    }else{
                        if (data.status == "success") {
                            self.$swal('','User Log Entry Status Changed Successfully.','success');
                        }
                    }
                    self.loadTimeLogData(self.technicianArr[self.currentUserIndex].id,self.datesArr[self.currentDateIndex].dateValue);//refresh page
                    self.currentLogIndex = 0;

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'gang-sheet-add-new-log')
                }
            });
        },
        editLogEntry(event,log,index) {
            var self = this;
            self.currentLogIndex = index;
            for(var i = 0;i < self.timeLogArr.length;i++) {
                if (self.timeLogArr[i] != undefined) {
                    if (self.timeLogArr[i].log != undefined && self.timeLogArr[i].log != null) {
                        for(var j = 0;j < self.timeLogArr[i].log.length;j++) {
                            if (self.timeLogArr[i].log[j].is_summary == 0) {
                                if (j == index) {
                                    this.$set(self.timeLogArr[i].log[j], 'is_update', 1);
                                    this.$set(self.timeLogArr[i].log[j], 'old_updated_value', self.timeLogArr[i].log[j].updated);
                                    /*if (self.timeLogArr[i].log[j].end_time != null && self.timeLogArr[i].log[j].end_time != "") {
                                        var currentEndTime = moment(self.timeLogArr[i].log[j].end).format("HH:mm");
                                        this.$set(self.timeLogArr[i].log[j], 'new_updated_value', currentEndTime);//end time
                                    }else{
                                        if (self.timeLogArr[i].log[j].start_time != null && self.timeLogArr[i].log[j].start_time != "") {
                                            this.$set(self.timeLogArr[i].log[j], 'new_updated_value', moment().format("HH:mm"));
                                        }else{
                                            var updatedTime = self.decimalToDuration(self.timeLogArr[i].log[j].updated);
                                            this.$set(self.timeLogArr[i].log[j], 'new_updated_value', updatedTime);
                                        }
                                    }*/
                                    this.$set(self.timeLogArr[i].log[j], 'new_updated_value', self.timeLogArr[i].log[j].updated);
                                    self.oldUpdatedDuration = self.timeLogArr[i].log[j].updated;
                                    this.$set(self.timeLogArr[i].log[j], 'updated_duration_error', "");
                                }else{
                                    this.$set(self.timeLogArr[i].log[j], 'is_update', 0);
                                    this.$set(self.timeLogArr[i].log[j], 'old_updated_value', self.timeLogArr[i].log[j].updated);
                                    this.$set(self.timeLogArr[i].log[j], 'updated_duration_error', "");
                                }
                            }
                        }
                    }
                }
            }
        },
        updateLogEntry(event,log,index,newValue,originalIndex) {
            var self = this;
            var error = false;

            if (self.timeLogArr[originalIndex] != undefined) {
                if (self.timeLogArr[originalIndex].log[index] != undefined) {
                    if (self.timeLogArr[originalIndex].log[index] != null) {
                        self.timeLogArr[originalIndex].log[index].updated_duration_error = "";

                        if (!self.timeLogArr[originalIndex].log[index].new_updated_value || self.timeLogArr[originalIndex].log[index].new_updated_value == ""
                            || self.timeLogArr[originalIndex].log[index].new_updated_value == null || self.timeLogArr[originalIndex].log[index].new_updated_value.trim() == "") {
                                self.timeLogArr[originalIndex].log[index].updated_duration_error = "Updated Duration Required.";
                                error = true;
                        }else{
                            if ( self.timeLogArr[originalIndex].log[index].new_updated_value == "-" || self.timeLogArr[originalIndex].log[index].new_updated_value == "."
                                || self.timeLogArr[originalIndex].log[index].new_updated_value == ".-" || self.timeLogArr[originalIndex].log[index].new_updated_value == "-.") {
                                self.timeLogArr[originalIndex].log[index].updated_duration_error = "Please check Updated Duration format.";
                                error = true;
                            }
                        }
                        /*else{
                            if ( self.timeLogArr[originalIndex].log[index].new_updated_value.indexOf("_") > -1 ) {
                                self.timeLogArr[originalIndex].log[index].updated_duration_error = "Please check Updated Duration format.";
                                error = true;
                            }
                        }*/

                        /*var endTime = "";
                        var flag = "";
                        if (self.timeLogArr[originalIndex].log[index].new_updated_value != null && self.timeLogArr[originalIndex].log[index].new_updated_value != "") {
                            if (self.timeLogArr[originalIndex].log[index].start_time != null && self.timeLogArr[originalIndex].log[index].start_time != "") {
                                var startTime = moment(self.timeLogArr[originalIndex].log[index].start).format("MM/DD/YYYY HH:mm:ss");
                                endTime = moment(self.datesArr[self.currentDateIndex].dateValue + " " + self.timeLogArr[originalIndex].log[index].new_updated_value).format("MM/DD/YYYY HH:mm:ss");
                                if (Date.parse(endTime) <= Date.parse(startTime)) {//end time is less than equal to start time
                                    self.timeLogArr[originalIndex].log[index].updated_duration_error = "End Time should be greater than Start Time.";
                                    error = true;
                                }
                                flag = "start-end";
                            }else{
                                endTime = self.timeLogArr[originalIndex].log[index].new_updated_value;
                            }
                        }*/

                        if (!error) {

                            var timeLogId = self.timeLogArr[originalIndex].log[index].id;
                            var newDuration = self.timeLogArr[originalIndex].log[index].new_updated_value;
                            var selectedDate = self.datesArr[self.currentDateIndex].dateValue;//selected date
                            console.log("timeLogId :: " + timeLogId);
                            console.log("newDuration :: " + newDuration);

                            var fields = {
                                id:timeLogId,
                                updated_duration:newDuration,
                                date:selectedDate,
                                /*updated_time:endTime,
                                flag:flag*/
                            }

                            self.loading = true;
                            $.ajax({
                                url: process.env.ROOT_API + "/gang-sheet/log/edit",
                                type: "POST",
                                headers: this.ajxHeaders,
                                data: fields,
                                dataType: "json",
                                success: function (data) {
                                    self.loading = false;
                                    self.addLog = false;
                                    //self.defaultClass = "admin-page-content customer-detail";
                                    self.indirectLaborCode = '';
                                    self.workOrder = '';
                                    self.workOrderArr = [];
                                    self.added_duration = "";
                                    self.added_duration_error = "";
                                    self.indirectLaborCodeError = "";
                                    self.workOrderError = "";
                                    self.uncheckSelectedLog();
                                    if (data.content != "" && data.content == "closed") {
                                        self.$swal('',data.message,'info');
                                    }
                                    self.loadTimeLogData(self.technicianArr[self.currentUserIndex].id,self.datesArr[self.currentDateIndex].dateValue);//refresh page

                                },
                                error: function (jqXHR, exception) {
                                    self.loading = false;
                                    self.generateStatusCodeMessage(jqXHR,false,'gang-sheet-add-new-log')
                                }
                            });


                        }
                    }
                }
            }
        },
        cancelLogEntry(event,log,index) {
            var self = this;
            self.oldUpdatedDuration = 0;
            for(var i = 0;i < self.timeLogArr.length;i++) {
                if (self.timeLogArr[i] != undefined) {
                    if (self.timeLogArr[i].log != undefined && self.timeLogArr[i].log != null) {
                        for(var j = 0;j < self.timeLogArr[i].log.length;j++) {
                            if (self.timeLogArr[i].log[j].is_summary == 0) {
                                console.log(self.timeLogArr[i].log[j].is_update);

                                this.$set(self.timeLogArr[i].log[j], 'is_update', 0);
                                this.$set(self.timeLogArr[i].log[j], 'updated', self.timeLogArr[i].log[j].old_updated_value);
                                this.$set(self.timeLogArr[i].log[j], 'updated_duration_error', "");

                            }
                        }
                    }
                }
            }
        },
        selectAll(evt) {
            var self = this;
            if (evt.target.checked) {
                self.select_all = true;
                self.approveAll = false;
                self.disapproveAll = false;
                self.showDisapproveBtn = false;
                self.showApproveBtn = false;
                self.showDelete = false;
                for(var i = 0;i < self.timeLogArr.length;i++) {
                    if (self.timeLogArr[i] != undefined) {
                        if (self.timeLogArr[i].log != undefined && self.timeLogArr[i].log != null) {
                            for(var j = 0;j < self.timeLogArr[i].log.length;j++) {
                                if (self.timeLogArr[i].log[j].is_summary == 0) {
                                    $("#selectLog" + j). prop("checked", true);
                                    if (self.findElementIndex(self.selectedLogArr,"id",self.timeLogArr[i].log[j].id) == -1) {
                                        self.selectedLogArr.push({
                                            id:self.timeLogArr[i].log[j].id,
                                            approved:self.timeLogArr[i].log[j].approved.toLowerCase(),
                                            index:j,
                                            wo_log_status:self.timeLogArr[i].log[j].wo_log_status
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
                var statusArr = [];
                for (var i = 0;i < self.selectedLogArr.length;i++) {
                    if (self.selectedLogArr[i].wo_log_status == "wip") {//if log in progress
                        //statusArr.push(self.selectedLogArr[i].wo_log_status);
                    }else{
                        statusArr.push(self.selectedLogArr[i].approved);
                    }
                }
                if (statusArr.length > 0) {
                    //check all values in array are equal or not
                    const allEqual = arr => arr.every( v => v === arr[0] );
                    var found = allEqual(statusArr);
                    if ( found ) {
                        self.showDelete = true;
                        if (statusArr[0] == "yes") {
                            //Yes then disapprove
                            self.approveAll = false;
                            self.disapproveAll = true;
                        }else if (statusArr[0] == "no") {
                            //No then approve
                            self.approveAll = true;
                            self.disapproveAll = false;
                        }
                    }else{
                        self.showDelete = true;
                        self.approveAll = true;
                        self.disapproveAll = true;
                    }
                }else{
                    self.showDelete = true;
                    self.approveAll = false;
                    self.disapproveAll = false;
                }
            }else{
                self.select_all = false;
                self.approveAll = false;
                self.disapproveAll = false;
                self.showDisapproveBtn = false;
                self.showApproveBtn = false;
                self.showDelete = false;
                for(var i = 0;i < self.timeLogArr.length;i++) {
                    if (self.timeLogArr[i] != undefined) {
                        if (self.timeLogArr[i].log != undefined && self.timeLogArr[i].log != null) {
                            for(var j = 0;j < self.timeLogArr[i].log.length;j++) {
                                if (self.timeLogArr[i].log[j].is_summary == 0) {
                                    $("#selectLog" + j). prop("checked", false);
                                }
                            }
                        }
                    }
                }
                self.selectedLogArr = [];
            }
        },
        hideMessageModal() {
            var self = this;
            self.closedErrorMsg = false;
            self.closedLineItems = [];
            $("#lineitem-message-modal").modal("hide");
        },
        decimalToDuration(value) {

            var duration = "00:00";

            var seconds = value * 3600;

            var hours = Math.floor(value);

            seconds -= hours * 3600;

            var minutes = Math.floor(seconds/60);

            seconds -= minutes * 60;

            if (hours < 10) {
                hours = "0"+hours;
            }

            if (minutes < 10) {
                minutes = "0"+minutes;
            }

            duration = hours + ":" + minutes;

            return duration;
        },
        onLocationChange() {
            var self = this;
            self.loadUsersAndDates('location');
            self.addLog = false;
            self.indirectLaborCode = '';
            self.workOrder = '';
            self.workOrderArr = [];
            self.added_duration = "";
            self.added_duration_error = "";
            self.indirectLaborCodeError = "";
            self.workOrderError = "";
        },
        timeLogDelete() {
            var self = this;
            self.$swal({
                title: 'Are you sure that you want to delete this Work Entry?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    var idArr = [];
                    for(var i = 0;i < self.selectedLogArr.length;i++) {
                        console.log(self.selectedLogArr[i].wostatus);
                        if (self.selectedLogArr[i].wostatus == "approved") {
                           //if wo in Approved
                        }else{
                            idArr.push(self.selectedLogArr[i].id);
                        } 
                        
                    }
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/etk/delete",
                        type: "POST",
                        data:{
                            id:idArr
                        },
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            if (data.status == 'success') {
                                var msg = "";
                                msg = data.content+" records have been deleted";
                                self.$swal('',msg,data.status);
                                // self.loadList();
                                self.loadTimeLogData(self.technicianArr[self.currentUserIndex].id,self.datesArr[self.currentDateIndex].dateValue);//refresh page
                                self.currentLogIndex = 0;
                            }else {
                                self.loadTimeLogData(self.technicianArr[self.currentUserIndex].id,self.datesArr[self.currentDateIndex].dateValue);//refresh page
                                self.currentLogIndex = 0;
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'delete-etk')
                        }
                    });
                } else {

                }
            });
        }
    }
}
</script>
<style scoped>

.gang-sheet .active-date,.gang-sheet .active-user  {
    color: #098de1;
}
.gang-sheet .table .section-title{
    font-family: 'SanFranciscoDisplaySemiBold', Arial;
    text-transform: uppercase;
}
.gang-sheet .table.table-borderless .active-date a,.gang-sheet .table.table-borderless .active-user  a{
    color: #098de1;
    border-bottom:2px solid #098de1;
    padding-bottom: 5px;
    padding-right: 10px;
    font-family: 'SanFranciscoDisplaySemiBold', Arial;
}
.gang-sheet .table.table-borderless a{
    color: #b3afaf;
}
.gang-sheet .table a,.gang-sheet .table th{
    font-family: 'SanFranciscoDisplayRegular', Arial;
}
.disable-link {
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ETK/GangSheet.vue